import PaymentForm from 'components/Forms/PaymentForm/PaymentForm';
import Banner from 'components/ui/ContentBlocks/Banner';
import Layout from 'components/ui/Layout';
import config from 'config';
import { useTranslation } from 'hooks/useTranslation';
import styles from './ReferFriendRewardLandingPage.module.scss';
import type { Brand } from 'types/Brand';
import type { PaymentInformationPayload, SubmitResponse } from 'types/Payment';

type Props = {
  brand: Brand | null;
};

const ReferFriendRewardLandingPage = ({ brand }: Props): JSX.Element => {
  const { t } = useTranslation();

  const processSubmit = async (
    id: string,
    payload: PaymentInformationPayload,
  ): Promise<SubmitResponse | null> => {
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    headers.append('X-API-KEY', process.env.QUNO_BACKEND_API_KEY as string);

    const response = await fetch(
      `${config.defaults.qunoApi}/v1/customer/${id}/reimbursementData`,
      {
        method: 'POST',
        body: JSON.stringify({
          accountHolderName: payload.accountHolderName,
          IBAN: payload.iban,
          BIC: payload.bic,
          paypalEmail: payload.paypalEmail,
        }),
        headers,
      },
    );

    if (response.status === 200) {
      return {
        success: true,
      };
    }

    return null;
  };

  return (
    <Layout
      title={`${t('referAFriend.rewardForm.metaTitle')} | ${brand?.name}`}
      metaDescription={t('referAFriend.rewardForm.metaDescription')}
      alternateSlugs={[]}
      footer={null}
      reducedFooter
      reducedHeader
      searchIndex={false}
      searchFollow={false}
      brand={brand}
    >
      <Banner
        blockId="refer-friend-reward-banner"
        preTitle={t('referAFriend.referalProgram')}
        title={t('referAFriend.yourRewards')}
        theme="dark"
      />
      <div className={styles.wrapper}>
        <PaymentForm onSubmit={processSubmit} page="ReferFriendReward" />
      </div>
    </Layout>
  );
};

export default ReferFriendRewardLandingPage;
